import React from "react";

let StarRating = require("./moderation-star-rating");

class ModerationUploadRating extends React.Component {
    getIconRating(iconRating) {
        if (!iconRating) {
            iconRating = "N/A";
        }
        return iconRating;
    }

    render() {
        let iconRating = this.getIconRating(this.props.iconRating),
            starRating = this.props.starRating;

        return (
            <div className="btn-group" role="group" aria-label="...">
                <input
                    type="text"
                    value={iconRating}
                    className="btn btn-default approval-rating"
                    readOnly
                />
                <button type="button" className="btn btn-default">
                    <StarRating
                        starRating={starRating}
                        creator={this.props.creator}
                        editable={false}
                    />
                </button>
            </div>
        );
    }
}

module.exports = ModerationUploadRating;
